import QuizStatusBadge from 'components/badge/QuizStatusBadge';
import { DivConst } from 'constants/divConst';

import type { QuizResponseType } from 'types/api/quizResponseType';
import { formatTimeToDate } from 'utils/app';
import { handleScrollToPopupEmbed } from 'utils/content';
import {
  formatPublishTerm,
  getLineProductionUrl,
  getProductionUrl,
  openLineProductionUrl,
  openProductionUrl,
} from 'utils/quiz';

import type { JSX } from 'react';

/**
 * クイズ作成編集 クイズ状態表示コンポーネント
 */
export default function WsQuizEditStatusInfo(props: { quiz: QuizResponseType }): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 公開情報の表示可否を返します。
   */
  const _isVisiblePublishInfo = (): boolean => {
    // 掲載(予約)ステータスの場合は表示
    if (props.quiz?.quizStatusDiv === DivConst.items.quizStatus.reserved.value) {
      return true;
    }
    // 一度でも掲載を迎えたクイズの場合は表示
    if (props.quiz?.publishedAt != null) {
      return true;
    }
  };

  /**
   * ポップアップ埋め込みタグの表示可否を返します。
   * WsContentEditPopupEmbed.tsx の埋め込みタグ表示条件と一致させます。
   */
  const _isVisiblePopupEmbed = (): boolean => {
    if (!props.quiz?.popupImageKey) {
      return false;
    }
    return _isVisiblePublishInfo();
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {props.quiz && (
        <div className="section-header user-detail">
          <div className="card-detail">
            {props.quiz.lineFlag ? (
              <>
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item">
                    <b>クイズ作成日</b>：{formatTimeToDate(props.quiz.createdAt, 'yyyy/MM/dd')}
                  </li>
                  <li className="list-inline-item">
                    <QuizStatusBadge quizStatusDiv={props.quiz?.quizStatusDiv} />
                  </li>
                  {_isVisiblePublishInfo() && (
                    <>
                      <li className="list-inline-item">
                        <b>公開期間</b>：
                        {formatPublishTerm({
                          quizStatusDiv: props.quiz.quizStatusDiv,
                          publishStartAt: props.quiz.publishStartAt,
                          publishEndAt: props.quiz.publishEndAt,
                          publishedAt: props.quiz.publishedAt,
                          terminatedAt: props.quiz.terminatedAt,
                        })}
                      </li>
                      <li className="list-inline-item">
                        <b>検索エンジン</b>：
                        <a>
                          {props.quiz.noIndexFlag && (
                            <span className="text-danger">インデックス対象外</span>
                          )}
                          {!props.quiz.noIndexFlag && <span>インデックス対象</span>}
                        </a>
                      </li>
                    </>
                  )}
                </ul>
                {_isVisiblePublishInfo() && (
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.quiz.quizStatusDiv === DivConst.items.quizStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openLineProductionUrl(props.quiz.lineCd)}
                        >
                          {getLineProductionUrl(props.quiz.lineCd)}
                        </a>
                      )}
                      {props.quiz.quizStatusDiv != DivConst.items.quizStatus.published.value && (
                        <span> {getLineProductionUrl(props.quiz.lineCd)}</span>
                      )}
                    </li>
                    <li className="list-inline-item">
                      <b>LINE友だち追加後のURL</b>：
                      {props.quiz.quizStatusDiv === DivConst.items.quizStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openProductionUrl(props.quiz.cd)}
                        >
                          {getProductionUrl(props.quiz.cd)}
                        </a>
                      )}
                      {props.quiz.quizStatusDiv != DivConst.items.quizStatus.published.value && (
                        <span> {getProductionUrl(props.quiz.cd)}</span>
                      )}
                    </li>
                  </ul>
                )}
                {_isVisiblePopupEmbed() && (
                  <ul className="list-unstyled list-inline mt-2">
                    <li className="list-inline-item">
                      <a href="#popup-embed" onClick={handleScrollToPopupEmbed}>
                        ポップアップ埋め込みタグ
                      </a>
                    </li>
                  </ul>
                )}
              </>
            ) : (
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <b>クイズ作成日</b>：{formatTimeToDate(props.quiz.createdAt, 'yyyy/MM/dd')}
                </li>
                <li className="list-inline-item">
                  <QuizStatusBadge quizStatusDiv={props.quiz?.quizStatusDiv} />
                </li>
                {_isVisiblePublishInfo() && (
                  <>
                    <li className="list-inline-item">
                      <b>公開期間</b>：
                      {formatPublishTerm({
                        quizStatusDiv: props.quiz.quizStatusDiv,
                        publishStartAt: props.quiz.publishStartAt,
                        publishEndAt: props.quiz.publishEndAt,
                        publishedAt: props.quiz.publishedAt,
                        terminatedAt: props.quiz.terminatedAt,
                      })}
                    </li>
                    <li className="list-inline-item">
                      <b>検索エンジン</b>：
                      <a>
                        {props.quiz.noIndexFlag && (
                          <span className="text-danger">インデックス対象外</span>
                        )}
                        {!props.quiz.noIndexFlag && <span>インデックス対象</span>}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.quiz.quizStatusDiv === DivConst.items.quizStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => openProductionUrl(props.quiz.cd)}
                        >
                          {getProductionUrl(props.quiz.cd)}
                        </a>
                      )}
                      {props.quiz.quizStatusDiv != DivConst.items.quizStatus.published.value && (
                        <span> {getProductionUrl(props.quiz.cd)}</span>
                      )}
                    </li>
                  </>
                )}
                {_isVisiblePopupEmbed() && (
                  <ul className="list-unstyled list-inline mt-2">
                    <li className="list-inline-item">
                      <a href="#popup-embed" onClick={handleScrollToPopupEmbed}>
                        ポップアップ埋め込みタグ
                      </a>
                    </li>
                  </ul>
                )}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
}
